import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AxiosError } from "axios";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: AxiosError) => {
        if (failureCount >= 3) {
          return false;
        }
        // Don't retry on authentication, authorization, or not-found errors (401, 403, 404)
        return !(
          error.response?.status === 401 ||
          error.response?.status === 403 ||
          error.response?.status === 404
        );
      },
    },
  },
});

export function TanstackQueryProvider(props: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
    </QueryClientProvider>
  );
}
